import * as React from "react";
import { Layout, Menu } from 'antd';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { accountMenuItems, transactionsRoutes } from "../routes";
import { AppContext } from "../context/AppContext";
const smdcLogo = require('../assets/images/smdc-logo-blue.png')

export const SideMenu: FC = () => {
    const context = React.useContext(AppContext);
    const { onLogout } = context;
    const [routes, setRoutes] = React.useState(transactionsRoutes);
    const navigate = useNavigate();
    const location = useLocation();

    const onOperationsMenuClick = (event: { key: string }) => {
        navigate(event.key);
    };

    const onAccountMenuClick = async (event: { key: string }) => {
        if(event.key === '/faqs') {
            window.open('https://smdc.com/contact/', '_blank');
        } else {
            onLogout()
        }
    };

    React.useEffect(() => {
        setRoutes((prevRoutes) => {
            if (JSON.stringify(prevRoutes) !== JSON.stringify(transactionsRoutes)) {
                return transactionsRoutes;
            }
            return prevRoutes;
        });
    }, []);
    


    return (
        <Layout.Sider style={{ height: '100%', position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 50 }}>
        <div className="h-32 flex py-8 px-4" style={{ alignItems: "center", justifyContent: "center"}}>
            <img src={smdcLogo} height={80} width={150} alt="" />
        </div>
        <hr className="mb-2"/>
        <Menu
            defaultSelectedKeys={['/transactions']}
            items={routes}
            className="menuItems"
            mode="inline"
            onClick={onOperationsMenuClick}
            selectedKeys={[location.pathname]}
        />
        <div className="absolute inset-x-0 bottom-0">
            <hr className="mt-2"/>
            <Menu
                items={accountMenuItems}
                className="accountMenu"
                mode="inline"
                onClick={onAccountMenuClick}
                selectedKeys={[]}
            />
        </div>
        
        </Layout.Sider>
    );
};